import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <h1 className="not-found-title">404</h1>
      <h2>Oops! The page you're looking for doesn't exist.</h2>
      <p className="not-found-message">
        This is not a fault.
      </p>
      <Link to="/" className="home-button">
        Go Back Home
      </Link>
    </div>
  );
};

export default NotFound;
